<template>
	<CardComponent :bordered="true" padding="md">
		<div class="space-y-4">
			<div
				v-for="(notification, index) in notifications"
				:key="index"
				class="flex gap-4 p-4 bg-surface rounded-lg"
			>
				<div class="flex-shrink-0">
					<div
						class="w-10 h-10 rounded-full bg-primary-light flex items-center justify-center"
					>
						<i
							:class="notification.icon"
							class="text-white text-sm"
						></i>
					</div>
				</div>
				<div class="flex-1">
					<h4 class="font-semibold text-text-primary">
						{{ notification.title }}
					</h4>
					<p class="text-sm text-text-secondary mt-1">
						{{ notification.message }}
					</p>
					<p class="text-xs text-text-secondary mt-2">
						{{ notification.time }}
					</p>
				</div>
			</div>
		</div>
	</CardComponent>
</template>

<script>
import CardComponent from '../Card.vue';

export default {
	name: 'NotificationsTab',
	components: {
		CardComponent,
	},
	data() {
		return {
			notifications: [
				{
					icon: 'fa fa-check-circle',
					title: 'Claim Submitted',
					message:
						'Your claim has been successfully submitted and is now under review.',
					time: '2 hours ago',
				},
				{
					icon: 'fa fa-info-circle',
					title: 'Documents Required',
					message:
						'Please upload your driving license and police abstract.',
					time: '1 day ago',
				},
				{
					icon: 'fa fa-user',
					title: 'Assigned to Adjuster',
					message:
						'Your claim has been assigned to John Doe for processing.',
					time: '3 days ago',
				},
			],
		};
	},
};
</script>

<style scoped></style>
